module.exports = __webpack_public_path__ + "templates/register-fields.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/customer-account/templates/register-fields.html
// module id = d1Ad
// module chunks = 1